import IPage from "../../../interfaces/page"
import CheckoutFormComponent from "../../Components/CheckoutForm/CheckoutForm.component"
import Width800Layout from "../../layouts/Width800/Width800.layout"


const CheckoutPage: React.FC<IPage> = () => {
    return <Width800Layout component={CheckoutFormComponent}></Width800Layout>
}

export default CheckoutPage